import * as React from "react";
import ContentCard from "../../../../ui-library/content-card/content-card";
import SourceLink from "../../../../ui-library/source-link/source-link";
import CardContent from "../../../../ui-library/content-card/card-content";
import { EventCategory } from "../../../../../utils/analytics";
import AnswerFlag from "../../../../ui-library/answers/answer-flag";
import CardHeading from "../../../../ui-library/content-card/card-heading";
import CardSubHeading from "../../../../ui-library/content-card/card-sub-heading";
import { COVID_SOURCES } from "../../../../../constants/sources";

interface DailyCaseByCountryProps {
  id: string;
  intentName: string;
  answerIndex: number | string;
  heading: string;
  subHeading?: string;
  headingDetail: string;
}

const DailyCaseCard: React.FC<DailyCaseByCountryProps> = ({
  id,
  intentName,
  answerIndex,
  heading,
  subHeading,
  headingDetail,
  children,
}) => {
  const sources = [COVID_SOURCES.OWID, COVID_SOURCES.JHU];

  return (
    <>
      <ContentCard id={id}>
        <CardContent>
          <CardHeading headingDetail={headingDetail}>{heading}</CardHeading>
          {subHeading && <CardSubHeading>{subHeading}</CardSubHeading>}

          {children}

          <SourceLink
            sources={sources}
            isDataOnly={true}
            eventCategory={EventCategory.CountryPage}
          />
        </CardContent>

        <AnswerFlag
          intentName={intentName}
          answerIndex={answerIndex}
          answerType="text"
        />
      </ContentCard>
    </>
  );
};

export default DailyCaseCard;
